import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { debounce } from "lodash";
import axios from "axios";

import { addEntities } from "../../entities";
import {
  FETCH_CONNECTEDPROFILE_FAILURE,
  FETCH_CONNECTEDPROFILE_REQUEST,
  FETCH_CONNECTEDPROFILE_SUCCESS
} from "../types";

const handleResponse = (
  response,
  dispatch,
  factoringProfile,
  id,
  limit,
  ordering,
  filters
) => {
  const data = normalize(response.results, [factoringProfile]);
  dispatch(addEntities(data.entities));
  dispatch(
    createAction(FETCH_CONNECTEDPROFILE_SUCCESS)({
      items: data.result,
      count: response.count,
      next: response.next,
      previous: response.previous,
      limit,
      ordering,
      filters
    })
  );
  return response;
};

export const next = (id, link, limit, ordering, filters) => async (
  dispatch,
  getState,
  { schema }
) => {
  try {
    dispatch(
      createAction(FETCH_CONNECTEDPROFILE_REQUEST)({
        limit,
        ordering,
        filters
      })
    );

    const response = await axios.get(link);
    handleResponse(
      response.data,
      dispatch,
      schema.factoringProfile,
      id,
      limit,
      ordering,
      filters
    );
  } catch (err) {
    dispatch(createAction(FETCH_CONNECTEDPROFILE_FAILURE)(err));
    throw err;
  }
};

const queryConnectedCarriersDebounced = debounce(
  async (dispatch, schema, api, factoringId, limit, ordering, filters) => {
    dispatch(
      createAction(FETCH_CONNECTEDPROFILE_REQUEST)({
        id: factoringId,
        limit,
        ordering,
        filters
      })
    );
    const response = await api.factoring.getConnectedCarriers(
      factoringId,
      ordering,
      limit,
      filters
    );
    return handleResponse(
      response,
      dispatch,
      schema.factoringProfile,
      factoringId,
      limit,
      ordering,
      filters
    );
  },
  1000,
  { trailing: true }
);

const queryConnectedProfile = (
  factoringId,
  ordering,
  limit,
  filters = {}
) => async (dispatch, getState, { api, schema }) => {
  try {
    await queryConnectedCarriersDebounced(
      dispatch,
      schema,
      api,
      factoringId,
      limit,
      ordering,
      filters
    );
  } catch (err) {
    dispatch(createAction(FETCH_CONNECTEDPROFILE_FAILURE)(err));
    throw err;
  }
};

export default queryConnectedProfile;
